// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
* core-alert
*/
:host .modal-message {
  padding: var(--core-padding-wide) var(--core-padding-default) var(--core-padding-thin) var(--core-padding-default);
  text-align: center;
  font-size: var(--core-font-sizes-content);
  color: var(--core-colors-dvDarkBlue);
}
@media screen and (min-width: 600px) {
  :host {
    padding: 0px;
  }
  :host .modal-content {
    max-width: 400px !important;
  }
}
:host button[ion-button] {
  border-radius: var(--core-border-radius);
  text-transform: initial !important;
}`, "",{"version":3,"sources":["webpack://./src/core-modules/components/core-alert/core-alert.component.scss"],"names":[],"mappings":"AAAA;;CAAA;AAKI;EACI,kHAAA;EAEA,kBAAA;EACA,yCAAA;EACA,oCAAA;AAFR;AAKI;EATJ;IAUQ,YAAA;EAFN;EAIM;IACI,2BAAA;EAFV;AACF;AAKI;EACI,wCAAA;EACA,kCAAA;AAHR","sourcesContent":["/**\r\n* core-alert\r\n*/\r\n@import '/src/theme/custom-variables.scss';\r\n:host{\r\n    .modal-message {\r\n        padding: var(--core-padding-wide) var(--core-padding-default) \r\n        var(--core-padding-thin) var(--core-padding-default);\r\n        text-align: center;\r\n        font-size: var(--core-font-sizes-content);\r\n        color: var(--core-colors-dvDarkBlue);\r\n    }\r\n\r\n    @media screen and (min-width: $screen-mobile-max-width) {\r\n        padding: 0px;\r\n\r\n        .modal-content {\r\n            max-width: 400px !important;\r\n        }\r\n    }\r\n\r\n    button[ion-button] {\r\n        border-radius: var(--core-border-radius);\r\n        text-transform: initial !important;\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
